// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"Main_scroll-black__XSJuS","main":"Main_main__h7H5_"};